import { useContext, VFC } from "react";
// Libraries
import { Route, Redirect, Switch } from "react-router-dom";
// Utils
import { AppContext } from "config/appProvider";
import { DASHBOARD } from "constants/Routes";
import { BU_TYPES } from "trading/constants";
// Routes
import { CommonRoutes, PATHS as commonPaths } from "./CommonRoutes";
import FarmerRoutes, { PATHS as farmerPaths } from "pages/Dashboard/routes/FarmerRoutes";
import { ImportsRoutes, PATHS as importsPaths } from "pages/Dashboard/routes/ImportsRoutes";
import LivestockRoutes, { PATHS as livestockPaths } from "pages/Dashboard/routes/LivestockRoutes";
import ProcessorRoutes, { PATHS as processorPaths } from "pages/Dashboard/routes/ProcessorRoutes";
import SettingsRoutes, { PATHS as settingsPaths } from "pages/Dashboard/routes/SettingsRoutes";
import SupplierRoutes, { PATHS as supplierPaths } from "pages/Dashboard/routes/SupplierRoutes";
import TradingRoutes, { PATHS as tradingPaths } from "trading/Routes";

const paths = [
  ...commonPaths,
  ...importsPaths,
  ...livestockPaths,
  ...settingsPaths,
  ...supplierPaths,
  ...tradingPaths,
  ...processorPaths,
  ...farmerPaths,
];

export const DashboardRoutes: VFC = () => {
  const {
    mainAppState: { selectedBUType },
  } = useContext(AppContext);

  const isProcessor: boolean = selectedBUType === BU_TYPES.processor;

  return (
    <Switch>
      <Route exact path={paths}>
        {isProcessor ? <ProcessorRoutes /> : <FarmerRoutes />}
        <ImportsRoutes />
        <LivestockRoutes />
        <SettingsRoutes />
        <SupplierRoutes />
        <TradingRoutes />
        <CommonRoutes />
      </Route>
      <Redirect to={DASHBOARD} />
    </Switch>
  );
};
